import React from 'react'
import dayjs from 'dayjs'
import { DatePicker } from 'antd'
import { Calendar } from 'lucide-react'
import { useSubmittedDates } from '../../hooks/calendar/use-submitted-dates'
import formatDate from '../../utils/date-formatter'
import { tokens } from '../../theme/tokens'

interface StyledDatePickerProps {
  widgetId: string
  value?: dayjs.Dayjs
  onChange?: (date: dayjs.Dayjs) => void
  allowClear?: boolean
  style?: React.CSSProperties
}

export const StyledDatePicker: React.FC<StyledDatePickerProps> = ({ widgetId, ...restProps }) => {
  const { fetchSubmittedDates, submittedDates } = useSubmittedDates({ widgetId })

  React.useEffect(() => {
    if (widgetId) {
      fetchSubmittedDates()
    }
  }, [widgetId, fetchSubmittedDates])

  // verifica si la fecha ya fue enviada
  const isSubmittedDate = (currentDate: dayjs.Dayjs): boolean => {
    if (!currentDate) return false
    return submittedDates.includes(formatDate(currentDate))
  }

  const defaultStyle = {
    width: '100%',
    borderRadius: '8px',
    padding: '8px 16px',
  }

  return (
    <DatePicker
      style={{ ...defaultStyle, ...(restProps.style || {}) }}
      placeholder='Seleccionar fecha'
      suffixIcon={<Calendar width={14} style={{ color: '#344054' }} />}
      cellRender={currentDate => {
        const dayjsDate = dayjs(currentDate)
        const isDateWithContent = isSubmittedDate(dayjsDate)
        return (
          <div
            style={
              isDateWithContent
                ? {
                    color: '#FFFFFF',
                    backgroundColor: tokens.colors.supporting.green[500],
                    borderRadius: '50%',
                    width: '25px',
                    height: '25px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginLeft: '7px',
                    fontWeight: 'bold',
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                  }
                : undefined
            }
          >
            {dayjsDate.date()}
          </div>
        )
      }}
      {...restProps}
    />
  )
}
